export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const setSuccessMessage = message => ({ type: SET_SUCCESS_MESSAGE, message });
export const setErrorMessage = message => ({ type: SET_ERROR_MESSAGE, message });

export const clearMessage = () => ({ type: CLEAR_MESSAGE });
